import React from 'react';
import { X } from 'lucide-react';
import { LatteButton, ToolbarButton } from '../common';

const NameModal = ({ isOpen, name, onNameChange, onSubmit, onClose, loading }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal">
        <div className="modal-header">
          <h3 className="modal-title">
            새 컨설팅 시작하기
          </h3>
          <button
            onClick={onClose}
            className="modal-close-btn"
          >
            <X className="w-5 h-5 text-gray-500" />
          </button>
        </div>
        
        <div className="modal-body">
          <div className="form-group">
            <label className="label">
              성함을 알려주세요
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => onNameChange(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && onSubmit()}
              placeholder="예: 홍길동"
              className="input"
              autoFocus
            />
          </div>
          
          <p className="form-help mt-4">입력하신 이름은 AI 컨설팅과 이력서 작성에 사용됩니다.</p>
        </div>
        
        <div className="modal-footer">
          <ToolbarButton
            onClick={onClose}
            variant="default"
            className="flex-1"
          >
            취소
          </ToolbarButton>
          <LatteButton
            onClick={onSubmit}
            disabled={!name.trim() || loading}
            className="flex-1"
          >
            {loading ? '시작 중...' : '컨설팅 시작'}
          </LatteButton>
        </div>
      </div>
    </div>
  );
};

export default NameModal;
